import { reactive } from '@vue/composition-api';

import { PaneState } from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamMap';
import {
  LIST_HARD_MAX_HEIGHT_PX,
  PANE_SIDE_HARD_MAX_WIDTH_PX,
} from '@/components/ExternalReports/EmergencyResponseTeam/consts';

interface UsePaneControlParams {
  paneStyleLimits?: {
    listMinHeightRate: number;
    listMaxHeightRate: number;
  };
}
interface UsePaneControlResult {
  paneState: PaneState;
  onChangeShowCarIcons: () => void;
}

export default function usePaneControl(params: UsePaneControlParams): UsePaneControlResult {
  const paneState = reactive<PaneState>({
    showCarIcons: true,
    photoTypeVisibility: {},
    paneStyleLimits: {
      listMinHeightRate: params.paneStyleLimits?.listMinHeightRate || 0,
      listMaxHeightRate: params.paneStyleLimits?.listMaxHeightRate || 0,
    },
    paneStyle: {
      paneSideMinWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
      paneSideMaxWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
      listMinHeight: LIST_HARD_MAX_HEIGHT_PX,
      listMaxHeight: LIST_HARD_MAX_HEIGHT_PX,
    },
  });

  const onChangeShowCarIcons = () => {
    paneState.showCarIcons = !paneState.showCarIcons;
  };

  return {
    paneState,
    onChangeShowCarIcons,
  };
}
